import React from 'react';
import NotFound from '../../NotFound';
import Prismic from 'prismic-javascript';
import {Link} from 'prismic-reactjs';
import PrismicConfig from '../../prismic-configuration';
import styles from './Navigation.scss';

// Declare your component
export default class Navigation extends React.Component {

  state = {
    callbackFn: null || this.props.callbackFn,
    doc: null,
    interactive: null || this.props.interactive,
    notFound: false,
  }
  	
  componentWillMount(){
    Prismic.api(PrismicConfig.apiEndpoint).then(api => {
      api.query(
        Prismic.Predicates.at('document.type', 'menu'),
      ).then(response => {
        this.setState({ doc: response.results[0] });
      });
    });
  }

  render() {
    if (this.state.doc) {
      const document = this.state.doc;
      const nav = document.data.nav;

      return (
        <nav className={styles.main_menu} onClick={this.state.callbackFn}>
          {nav.map(function(nav, index){
            const primaryLabel = nav.primary.label[0].text;
            const primaryLink = nav.primary.link;
            const subItems = nav.items;

            if(subItems.length === 0){
              return (
                <React.Fragment key={'fragment'+index}>
                  <a href={Link.url(primaryLink, PrismicConfig.linkResolver)} key={'top_item'+index} className={styles.menu_item} >{primaryLabel}</a>
                </React.Fragment>
              );
            } else if(subItems){
              return(
                <React.Fragment key={'fragment'+index}>
                  <a href={Link.url(primaryLink, PrismicConfig.linkResolver)} key={'top_item'+index} className={styles.menu_item} >{primaryLabel}</a>
                  <ul key={'sub_items'+index}>
                    {subItems.map(function(subItems, index) {
                      if(subItems.sub_nav_link_lable !== ''){
                        return (
                          <li key={'list'+index}>
                            <a href={Link.url(subItems.sub_nav_link, PrismicConfig.linkResolver)} key={'sub_item'+index} className={styles.menu_item}>{subItems.sub_nav_link_lable[0].text}</a>
                          </li>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </ul>
                </React.Fragment>
              );
            } else {
              return null;
            }
          })}
        </nav>
      );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <h1>Loading</h1>;
  }
}


// WEBPACK FOOTER //
// ./src/Components/Navigation/Navigation.js